import React, { Component } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from '!isomorphic-style-loader!css-loader!../ManageBanner/filepicker.css';
import cx from 'classnames';
import { toastr } from 'react-redux-toastr';
import { change } from 'redux-form';
import { api } from '../../../config';
import { connect } from 'react-redux';

export class IconDropzone extends Component {
  constructor(props) {
    super(props);
    this.addedfile = this.addedfile.bind(this);
    this.success = this.success.bind(this);
    this.dropzone = null;
  }


  success = (file, fromServer) => {
    const { onUploadSuccess } = this.props;
    const fileName = fromServer.fileName;
    if (onUploadSuccess) {
      onUploadSuccess(fileName);
    }
  };

  addedfile = (file) => {
    // Optional: add validation for icon size/type here
    if (file && file.size > (1024 * 1024 * 2)) { // 2MB max
      toastr.error('Maximum upload size Exceeded! ', 'Try with smaller size image');
      this.dropzone.removeFile(file);
    }
    if (file && file.accepted === false) {
      setTimeout(() => {
        toastr.error('Error!', 'You are trying to upload invalid image file. Please upload PNG, JPG & JPEG format image file.');
        this.dropzone.removeFile(file.name);
      }, 1000);
    }
  };

  render() {
    const { defaultMessage, className, subTextClass, subText } = this.props;
    const apiEndpoint = api && api.apiEndpoint;
    const djsConfig = {
      dictDefaultMessage: '',
      addRemoveLinks: false,
      uploadMultiple: false,
      maxFilesize: 2, // 2MB
      acceptedFiles: 'image/jpeg,image/png,image/svg+xml,image/jpg',
      dictMaxFilesExceeded: 'Remove the existing image and try upload again',
      previewsContainer: false,
      hiddenInputContainer: '.dzInputContainer',
    };
    var componentConfig = {
      iconFiletypes: ['.jpg', '.png', '.svg'],
      multiple: false,
      showFiletypeIcon: false,
      postUrl: `${apiEndpoint}/uploadShopCategoryIconImage`
    };
    const eventHandlers = {
      init: dz => this.dropzone = dz,
      success: (...args) => this.success(...args),
      addedfile: (...args) => this.addedfile(...args)
    };
    return (
      <div className={cx('listPhotoContainer')}>
        <div className={cx('dzInputContainer', className)}>
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
          >
            {defaultMessage}
          </DropzoneComponent>
        </div>
        <p className={cx(subTextClass, 'droupText')}>
          {subText}
        </p>
      </div>
    );
  }
}

const mapDispatch = { change };

export default withStyles(s)(connect(null, mapDispatch)(IconDropzone)); 